import React, { useEffect } from "react";

import "./index.scss";

import { useNavigation } from "hooks/useNavigation";
import gsap from "gsap";

import HomeCard from "components/HomeCard";

import background from "assets/background/background-homepage.webp";

const Home = () => {
  const navigate = useNavigation();

  useEffect(() => {
    gsap
      .timeline()
      .to(".card-container .home-card", {
        opacity: 0,
        duration: 0,
      })
      .to(".card-container .home-card", {
        opacity: 1,
        stagger: 0.2,
      });
  }, []);

  return (
    <div
      className="home page"
      style={{
        backgroundImage: `url(${background})`,
      }}
    >
      <div className="card-container">
        <div className="card-left-container col-8">
          <HomeCard
            media={require("assets/video/home/screensaver.mp4")}
            poster={require("assets/video/home/poster/screensaver.webp")}
            title="Campari world"
            subtitle={"Tap to discover"}
            bottomText={false}
            onClick={() => navigate("/video")}
          />
          <HomeCard
            media={require("assets/video/home/signature.mp4")}
            poster={require("assets/video/home/poster/signature.webp")}
            largeHeader
            header="cannes tfwa 2023 exclusive"
            title="signature cocktail"
            subtitle={"Tap to discover"}
            onClick={() => navigate("/signature")}
          />
        </div>

        <HomeCard
          media={require("assets/video/home/cocktails.mp4")}
          poster={require("assets/video/home/poster/cocktails.webp")}
          largeHeader
          header="Campari’s Iconic"
          title={"cocktails"}
          subtitle={"Tap to discover"}
          onClick={() => navigate(`/menu`)}
          customClass="col-4_5"
        />
      </div>
    </div>
  );
};

export default Home;
